import type { CartEntry, Product } from '@maestro/data-layer'

interface MapCartEntryToProductOptions {
  includePromotions?: boolean
}

export function mapCartEntryToProduct(
  entry: CartEntry,
  _options: MapCartEntryToProductOptions = {}
): Product {
  return {
    name: entry.productName,
    gallery: [],
    urlPath: entry.urlPath,
    variantAttributes: [],
    variants: [],
    id: entry.productId,
    defaultVariantId: entry.variantId,
    price: entry.priceBase,
    image: entry.image,
    productType: entry.productType,
    type: entry.type,
    brand: entry.brand,
    labels: entry.labels,
    stock: entry.stock[0],
    categories: entry.categories,
  }
}
